import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { SloganProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import sunbitSignatureContrast from '@sunbit-dev/purchase-common/src/assets/sunbit-signature-contrast.svg';

export const Slogan = styled(({ className }: SloganProps) => {
  const { t } = useTranslation('healthcare_landing_modal');

  const [specialSloganText, simpleSloganText] = t('sunbit_slogan', { returnObjects: true });

  return (
    <div {...{ className }}>
      <img {...{ className: 'powered-by-logo', src: sunbitSignatureContrast, alt: t('sunbit_signature') }} />

      <p className="slogan">
        <span className="special">{specialSloganText}</span>
        {simpleSloganText}
      </p>
    </div>
  );
})`
  ${styles.Slogan}
`;
